import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-106">
      {/* Decorative element */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4A574] to-transparent opacity-30" data-id="element-107" />

      <div className="container mx-auto px-4 md:px-6" data-id="element-108">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-109">
          <div className="flex-1" data-id="element-110">
            <FadeIn data-id="element-111">
              <div className="inline-flex items-center gap-2 text-[#D4A574] font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-112">
                <Sparkles className="h-4 w-4" data-id="element-113" />
                <span data-id="element-114">The Missing Piece</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D1B4E] mb-6 leading-tight" data-id="element-115">
                Understanding isn’t enough. <br data-id="element-116" />
                <span className="italic text-[#D4A574]" data-id="element-117">Integration</span> is
                the key.
              </h2>
            </FadeIn>
          </div>

          <div className="flex-1" data-id="element-118">
            <FadeIn delay={0.2} direction="left" data-id="element-119">
              <div className="bg-[#FAF7F2] p-8 md:p-10 rounded-2xl border border-[#E8D5D5] shadow-sm" data-id="element-120">
                <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-121">
                  The real problem isn’t trauma. It’s{' '}
                  <strong className="text-[#2D1B4E]" data-id="element-122">fragmentation</strong>.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-123">
                  You’ve learned to manage your feelings, but healing happens
                  when you integrate the parts of you that feel separate. This
                  book is your guide to reunite those parts—gently, at your own
                  pace.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}